import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "my-2.5" }
const _hoisted_2 = ["readonly", "placeholder", "maxlength"]
const _hoisted_3 = {
  key: 0,
  class: "input__warning text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      class: _normalizeClass(["resize-none rounded-md border border-solid border-text-area text-black-secondary p-3 w-full h-52", {'invalid': _ctx.isInvalid }]),
      readonly: _ctx.readonly,
      placeholder: _ctx.placeholder,
      maxlength: _ctx.maxLength,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bindValue) = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInputChange && _ctx.onInputChange(...args))),
      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
    }, null, 42, _hoisted_2), [
      [_vModelText, _ctx.bindValue]
    ]),
    (_ctx.isErrorShowMessage && _ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.t(_ctx.error)), 1))
      : _createCommentVNode("", true)
  ]))
}